import { CreditAndPromoCodesScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <CreditAndPromoCodesScreen />;
}
